<template>
  <div class="min-h-screen xl:flex">
    <app-sidebar />
    <Backdrop />
    <div
      class="flex-1 transition-all duration-300 ease-in-out"
      :class="[isExpanded || isHovered ? 'lg:ml-(--sidebar-max) lg:max-w-[calc(100%_-_var(--sidebar-max))]' : 'lg:ml-(--sidebar-min) lg:max-w-[calc(100%_-_var(--sidebar-min))]']"
    >
      <app-header />
      <div :class="['relative px-4 pt-2 pb-4 mx-auto max-w-(--breakpoint-2xl) md:px-6 md:pt-3 md:pb-6', customClasses]">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppSidebar from './AppSidebar.vue'
import AppHeader from './AppHeader.vue'
import { useSidebar } from '@/composables/useSidebar'
import Backdrop from './Backdrop.vue'
const { isExpanded, isHovered } = useSidebar()

interface Props {
  customClasses?: string;
}

defineProps<Props>()
</script>
